var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React from 'react';
import styled from 'react-emotion';
import { LangCurrWrapper, SelectorBody, Title } from './ChannelSelector';
import { CheckboxWrapper } from '../Checkbox/CheckboxGroup';
const SelectorWrapper = styled('div') `
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  max-width: 16em;
  border: 1px solid #e8e8e8;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.07);
  background-color: white;

  /* Style the wrapper around language and currency radios */
  ${LangCurrWrapper} {
    padding: 1rem;
    margin: 0.5rem;
    font-size: 0.875rem;
    ${CheckboxWrapper} {
      margin-top: 1rem;
      &:first-child {
        margin-top: 0;
      }
    }
  }

  ${SelectorBody} {
    padding: 1rem;
  }

  ${Title} {
    margin: 0;
    padding: 0;
    padding-bottom: 1rem;
    font-weight: 600;
    font-size: 0.875em;
    border-bottom: 1px solid #e8e8e8;
    text-align: center;
  }
`;
const MiniSelector = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(SelectorWrapper, Object.assign({}, props), children);
};
/** @component */
export default MiniSelector;
//# sourceMappingURL=MiniSelector.js.map